/**
 * Formats geospatial coordinates into a Google Maps URL
 * @param coordinates - Object containing latitude, longitude, and elevation
 * @returns Google Maps URL string
 */
export const formatGeospatialLink = (coordinates: {
  lat: number
  lng: number
  elevation: number
}): string => {
  return `https://www.google.com/maps/search/?api=1&query=${coordinates.lat},${coordinates.lng}`
}
